export default "__VITE_ASSET__BugFb2kK__"